import { baseSystemFieldKeyList } from '../../constants/forms/ticketFormFields';
import { UIFieldRuleOnForm } from '../../hooks/ticketDetailPage/useAgentFormById';
import { IFieldDefinition, TicketSystemFieldsKey } from '../../model/types';

export const getFieldRuleByKey =
    (fieldDefinition: IFieldDefinition) =>
    ({ key }: UIFieldRuleOnForm) =>
        key === fieldDefinition.key;

export const reorder = (list: IFieldDefinition[], startIndex: number, endIndex: number): IFieldDefinition[] => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

export const reorderFields = (fields: IFieldDefinition[]): IFieldDefinition[] => {
    const baseSystemFieldsList: IFieldDefinition[] = baseSystemFieldKeyList.reduce((acc, fieldKey) => {
        const fieldIndex = fields.findIndex((field) => field.key === fieldKey);

        return [...acc, fields[fieldIndex]];
    }, []);

    const filteredList = fields.filter((field) => !baseSystemFieldKeyList.includes(field.key as TicketSystemFieldsKey));

    return [...baseSystemFieldsList, ...filteredList];
};
export type customDroppableObject = { index: number; droppableId: string | number };

/**
 * Moves an item from one list to another list.
 */
export const move = (
    source: IFieldDefinition[],
    destination: IFieldDefinition[],
    droppableSource: customDroppableObject,
    droppableDestination: customDroppableObject
): Record<any, IFieldDefinition[]> => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(droppableSource.index, 1);

    destClone.splice(droppableDestination.index, 0, removed);

    const result = {};

    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;

    return result;
};

export const isDraggableDisabled = (key: string): boolean =>
    baseSystemFieldKeyList.includes(key as TicketSystemFieldsKey);

export const decideFieldText = (systemField: boolean): string => (systemField ? 'systemField' : 'customField');
